import { cn } from "@/utils/cn";
import React, { useState } from "react";

const IMG_ORIGIN = "http://img-vcr.oss-cn-beijing.aliyuncs.com";
const COS_ORIGIN = "https://img-poster-editor-1300308946.cos.ap-beijing.myqcloud.com";
const OSS_ORIGIN = "http://n8n-workflow-file.oss-cn-beijing.aliyuncs.com";
const MIUTA_ORIGIN = "https://sg-miuta-resource.oss-ap-southeast-1.aliyuncs.com";
const IMG_EFFECT_SG_ORIGIN = "https://img-effect-sg-new-1300308946.cos.accelerate.myqcloud.com";
const ARK_BEIJING_ORIGIN = "https://ark-content-generation-v2-cn-beijing.tos-cn-beijing.volces.com"

function toStaticProxyUrl(url: string): string {
  if (!url || url.startsWith("/cos/") || url.startsWith("/oss/")) return url;
  const isDev = typeof import.meta !== "undefined" && !!import.meta.env?.DEV;
  if (!isDev) return url;
  try {
    const u = new URL(url);
    if (u.origin === IMG_ORIGIN) {
      const path = u.pathname + (u.search || "");
      return `/img${path}`;
    }
    if (u.origin === COS_ORIGIN) {
      const path = u.pathname + (u.search || "");
      return `/cos${path}`;
    }
    if (u.origin === OSS_ORIGIN) {
      const path = u.pathname + (u.search || "");
      return `/oss${path}`;
    }
    if (u.origin === MIUTA_ORIGIN) {
      const path = u.pathname + (u.search || "");
      return `/miuta${path}`;
    }
    if (u.origin === IMG_EFFECT_SG_ORIGIN) {
      const path = u.pathname + (u.search || "");
      return `/imgeffectsg${path}`;
    }
    if (u.origin === ARK_BEIJING_ORIGIN) {
      const path = u.pathname + (u.search || "");
      return `/arkbeijing${path}`;
    }
    return url;
  } catch {
    return url;
  }
}

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  // 继承所有img标签的属性
}

export const Image = React.forwardRef<HTMLImageElement, ImageProps>(
  ({ className = "", onLoad, onError, ...props }, ref) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
      setIsLoaded(true);
      setHasError(false);
      onLoad?.(e);
    };

    const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
      setIsLoaded(false);
      setHasError(true);
      onError?.(e);
    };

    if (hasError) return <div className={`${className} bg-[rgba(234,236,240,1)]`} {...props}></div>;
    return (
      props.src && <img 
        ref={ref} 
        className={cn(className, !isLoaded && 'bg-[rgba(234,236,240,1)]')}
        onLoad={handleLoad}
        onError={handleError}
        crossOrigin="anonymous" 
        {...props}
        src={props.src ? toStaticProxyUrl(props.src) : props.src}
      />
    );
  }
);

// 设置displayName便于调试
Image.displayName = "Image";
